import React from "react";
import Page from "./Page";
export default class extends React.Component {
    render() {
        return React.createElement(Page, null);
    }
}
